import type { TemporaryReferenceData } from '../contexts/ReferenceDataContext';

interface NavigateToAddReferenceFormParams {
  initialImage?: string;
  imageBlob?: File;
  source: 'paste' | 'drag-drop' | 'web-share-target';
  title?: string;
  description?: string;
  sourceURL?: string;
  category?: string;
}

export function createTemporaryReferenceData(params: NavigateToAddReferenceFormParams): TemporaryReferenceData {
  return {
    initialImage: params.initialImage,
    imageBlob: params.imageBlob,
    source: params.source,
    title: params.title,
    description: params.description,
    sourceURL: params.sourceURL,
    category: params.category,
    timestamp: Date.now()
  };
}

export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

export function createObjectURLFromFile(file: File): string {
  return URL.createObjectURL(file);
} 